"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryNTimesWithExponentialPause = exports.retryNTimesWithPause = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
async function retryNTimesWithPause(nAttempts, pauseMsecs, shouldRetry, f, calcBackOff) {
    const ctx = { fn: "retryNTimesWithPause", nAttempts, pauseMsecs };
    let attempt = 0;
    while (true) {
        try {
            const result = await f();
            return result;
        }
        catch (err) {
            attempt += 1;
            if (attempt >= nAttempts || (shouldRetry && !shouldRetry(err))) {
                commons_logs_1.log.warn(Object.assign(Object.assign({}, ctx), { err }), "async function has failed too many times, re-throwing the error.");
                throw err;
            }
            else {
                commons_logs_1.log.warn(Object.assign(Object.assign({}, ctx), { err, attempt }), "async function has failed.  Waiting and then retrying.");
                await new Promise((resolve) => setTimeout(resolve, pauseMsecs));
                if (calcBackOff) {
                    pauseMsecs = calcBackOff(attempt);
                }
                continue;
            }
        }
    }
}
exports.retryNTimesWithPause = retryNTimesWithPause;
async function retryNTimesWithExponentialPause(nAttempts, baseMsec, capMsec, shouldRetry, f) {
    function exponential(attempts) {
        return Math.min(capMsec, baseMsec * 2 ** attempts);
    }
    return retryNTimesWithPause(nAttempts, baseMsec, shouldRetry, f, exponential);
}
exports.retryNTimesWithExponentialPause = retryNTimesWithExponentialPause;
//# sourceMappingURL=GeneralUtils.js.map